







































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IWorldCountry } from '../models/world';

@Component({})
export default class CountriesList extends Vue {

	public get countries(): IWorldCountry[] {
		return this.$store.getters['world/getSummary'].countries;
	}
	public selected: number | undefined = -1;
	public get selectedCountry(): string {
		return this.$store.getters['world/getCountryId'];
	}
	public get totalPrevCount() {
		return this.$store.getters['world/getTotalPrevCount'];
	}
	@Watch('selected')
	private onSelectChange(val: number | undefined, oldVal: number | undefined) {
		if (val !== undefined && val >= 0) {
			const cId = this.countries[val];
			this.$store.dispatch('world/updateCountryId', cId.code);
		} else {
			this.$store.dispatch('world/updateCountryId', '');
		}
	}

	@Watch('selectedCountry')
	private onCountryChange(val: string, oldVal: string) {
		this.selected = this.countries.findIndex((c) => c.code === val);
	}

	private getClassDiff(prev: number) {
		if (prev > 0) {
			return 'error--text';
		} else if (prev < 0) {
			return 'success--text';
		} else {
			return 'info--text';
		}
	}
}
